import {
	MutationFunction,
	QueryKey,
	UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'

interface UseInvalidateMutationParams<TData, TVariables, TError, TContext> {
	mutationFn: MutationFunction<TData, TVariables>
	invalidateKeys?: QueryKey[]
	options?: UseMutationOptions<TData, TError, TVariables, TContext>
}

function useInvalidateMutation<TData = unknown, TVariables = void, TError = unknown, TContext = unknown>({
	mutationFn,
	invalidateKeys = [],
	options
}: UseInvalidateMutationParams<TData, TVariables, TError, TContext>) {
	const queryClient = useQueryClient()

	return useMutation<TData, TError, TVariables, TContext>({
		mutationFn,
		...options,
		onSuccess: async (data, variables, context) => {
			await Promise.all(
				invalidateKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))
			)

			if (options?.onSuccess) {
				await options.onSuccess(data, variables, context)
			}
		}
	})
}

export default useInvalidateMutation
